import MemoriesModal from "./MemoriesModal";
export default MemoriesModal;
